import * as ReactQuery from "@tanstack/react-query";
import * as Brm from "services/brm";

/**
 * Returns baseline for the given SCTM
 *
 * @param {string} sctmId - uuid of the SCTM
 */
export const getSctmBaseline = ({ sctmId }) => {
  return Brm.sctmApi.getSCTMBaseline(sctmId);
};

/**
 * React-query hook for getting baseline
 *
 * @param {string} sctmId - uuid of sctm
 * @param {object} config - react-query configuration object
 * @returns react-query for getSctmBaseline
 */
export const useSctmBaseline = ({ sctmId, config = {} }) => {
  return ReactQuery.useQuery({
    ...config,
    queryKey: ["sctmBaseline", sctmId],
    queryFn: () => getSctmBaseline({ sctmId }),
  });
};
